<script>
import draggable from 'vuedraggable';
import { mapState, mapGetters, mapActions } from 'vuex';

const meetFormStore = {
    namespaced: true,
    state:{
        tags: [],
        meet: null
    },
    mutations:{
        'SET_TAGS'(state, data){
            state.tags = data;
        },
        'SET_MEET'(state, data){
            state.meet = data;
        },
        'ADD_TAG'(state, data){
            state.tags.push(data);
        }
    },
    actions:{
        initStore({commit}, {tags=null, meet=null}){
            commit('SET_TAGS', tags);
            commit('SET_MEET', meet);
        },
        addTag({commit}, newTag){
            commit('ADD_TAG', newTag);
        }
    }
}

export default {
    components:{
        'vue-draggable': draggable,
    },
    data: function(){
        return {
            participants: [],
            topics: null,
            users_list: [],
            plannedStartHour: "",
            plannedEndHour: "",
            hours: [],
        }
    },
    beforeMount(){
        this.$store.registerModule('meetFormModule', meetFormStore);
        this.getInitialData()
    },
    computed:{
        selectedParticipantesIds: function() {
            var arrayPaste = []
            arrayPaste = this.participants.map(a=>a.id)
            return arrayPaste
        },
        plannedStartHours: function(){
            return this.compareHoursOptions(this.plannedEndHour, this.hours, this.hourLesserComparator)
        },
        plannedEndHours: function(){
            return this.compareHoursOptions(this.plannedStartHour, this.hours, this.hourGreaterComparator)
        },
        ...mapState('meetFormModule', ['meet'])
    },
    methods:{
        getInitialData(){
            var _meet = JSON.parse(this.$attrs['data-meet']);
            var _tags = JSON.parse(this.$attrs["data-tags"])

            this.initStore({meet: _meet, tags: _tags});

            this.topics = JSON.parse(this.$attrs['data-topics']);
            this.participants = JSON.parse(this.$attrs['data-participants-users']);
            this.users_list = JSON.parse(this.$attrs["data-users"])
            this.hours = JSON.parse(this.$attrs["data-hours"])
        },
        compareHoursOptions(selectedHour, hours, comparator){
            if(!!selectedHour){
                let timeSplit = selectedHour.split(":")
                let hour = parseInt(timeSplit[0])
                let minute = parseInt(timeSplit[1])
                
                return hours.filter(o=>{
                    let timeSplitOption = o.value.split(":")
                    let hourOption = parseInt(timeSplitOption[0]);
                    let minuteOption = parseInt(timeSplitOption[1]);

                    return comparator(hourOption, hour, minute, minuteOption);
                })
            }
            return hours
        },
        participantsCustomLabel({email, name}){
            return `${name} - ${email}`
        },
        hourGreaterComparator: function(hourOption, hour, minute, minuteOption){
            if(hourOption>hour){
                return true
            }
            if(hourOption==hour){
                if(minuteOption>minute){
                    return true
                }
                return false
            }
            return false
        },
        hourLesserComparator: function(hourOption, hour, minute, minuteOption){
            if(hourOption<hour){
                return true
            }
            if(hourOption==hour){
                if(minuteOption<minute){
                    return true
                }
                return false
            }
            return false
        },
        ...mapActions('meetFormModule', ['initStore'])
    }
}
</script>